<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>

    <div class="l-contents">

      <h1 class="l-pageTitle">削除した診断項目一覧</h1>

      <div class="l-contentsBox">
        <p class="l-text">「復活する」ボタンの押下で、元の場所に再表示できます。完全な削除はフリーマインドまでお問合わせください。</p>
                  

        <table class="table-base audit-table">
          <colgroup>
            <col width="10%">
            <col width="20%">
            <col width="20%">
            <col >
            <col >
            <col >
          </colgroup>
          <thead>
            <tr>
              <th>条名称</th>
              <th>項名称</th>
              <th>対象者</th>
              <th>チェック項目</th>
              <th>完全削除</th>
              <th>復活</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(item,key) in deleteList" :key="key">
              <td>
                {{ item["diagSection"]["sectionNm"] }}</td>
              <td>{{ item["diagSubSection"]["subSectionNm"] }}</td>
              <td>{{ item["subjects"] }}</td>
              <td style="white-space: pre-wrap;">{{ item["checkItem"] }}</td>
              <td>
                <div class="btn-delete js-btn-delete " @click="register_delete(item['itemId'])" :disabled="isProcessing"><a >完全削除</a></div>
              </td>
              <td>
                <div class="btn-delete js-btn-delete " @click="register_undo(item['itemId'])" :disabled="isProcessing"><a >復活する</a></div>
              </td>
            </tr>

          </tbody>
        </table>
  
      </div>
    </div>
  </main>
</template>

<script>

import Loading from '@/components/parts/common/Loading.vue';

export default {
  name: 'CorporateList',
  components: {
    Loading,
  },
  data() {
    return {
      userCorporate: null,
      pageInfo: {},
      corporateList: [],
      corporatePlanOptionList: [],
      isProcessing: false,
      isSystemAdmin: false,
      isAllPermission: false,
      isAdmin: false,
      deleteList: '',
    }
  },
  created: async function(){
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isSystemAdmin = authority.isSystemAdmin;
    this.isAllPermission = authority.isAllPermission;
    this.isAdmin = authority.isAdmin;
    this.isProcessing = false;
    this.getList();
  },
  methods: {
    async getList() {

      this.deleteList=[];
      this.isProcessing = true;

      let res = await this.$axios.post('/ld/api/master/diag/getDiagSectionDeleteList', {});
      if (res.status === 200) {
        this.deleteList = res.data.deleteList;
      }else{
        this.$toast.error(res.data.message);
      }

      this.isProcessing = false;

    },
    async register_delete(itemId) {
        if (window.confirm("本当に削除しますか？")) {
          this.isProcessing = true;

          let res = await this.$axios.post('/ld/api/master/diag/storeDiagItemPermanentDelete', {'itemId':itemId});
          if (res.status === 200) {
            this.$toast.info('完全削除処理が完了しました');
            await this.getList();

          } else {
            this.$toast.error(res.data.message);
          }
          this.isProcessing = false;
        }
      },

    async register_undo(itemId) {
          this.isProcessing = true;

          let res = await this.$axios.post('/ld/api/master/diag/storeDiagItemDeleteUndo', {'itemId':itemId});
          if (res.status === 200) {
            this.$toast.info('復活処理が完了しました');
            await this.getList();

          } else {
            this.$toast.error(res.data.message);
          }
          this.isProcessing = false;
      },

  }
}
</script>
